export const formatDatePickerDate = (value: string) => {
  const date = new Date(value);

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
